import "./Loader.css";
export default function Loader() {
  return (
    <div id="loading">
      <div class="loader">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
      </div>
    </div>
  );
}
